/**
 * Program Benefits 1044 — BDU "Learn More"
 * Tinted band, heading + gradient rule, and a stack of rich-text cards that clamp to
 * 90px with a Read more / View less toggle.
 */

export const PROGRAM_BENEFITS_1044_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Content cards",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "",
    meta_description: "",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_BENEFITS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Learn More",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Learn More",
    },
    {
      fieldName: "title_start_color",
      label: "Heading colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under heading — start (blue)",
      value: "#1F3D56",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#1F3D56",
    },
    {
      fieldName: "gradient_color_2",
      label: "Rule under heading — end (blue)",
      value: "#7CB5E6",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#7CB5E6",
    },
    {
      fieldName: "desktop_background_color",
      label: "Band background",
      value: "#CBCBCB",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#CBCBCB",
    },
    {
      fieldName: "subtitle_color",
      label: "Card border",
      value: "#E2E8F0",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#E2E8F0",
    },
    {
      fieldName: "card_hover_background_color",
      label: "Card surface",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "description_color",
      label: "Card title / body colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "load_more_button",
      label: "Expand toggle label (collapsed state)",
      value: "Read more",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Read more",
      defaultValue: "Read more",
    },
    {
      fieldName: "gradient_color_3",
      label: "Expand toggle gradient — start",
      value: "#F60214",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#F60214",
    },
    {
      fieldName: "gradient_color_4",
      label: "Expand toggle gradient — end",
      value: "#A10113",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#A10113",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Card title (optional)",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leave empty to start with the rich text",
      defaultValue: "",
    },
    {
      header: "Content",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Long-form copy — clamps to 90px with a Read more toggle",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
